import React, { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';

import { Button } from 'components';
import { PageTitle } from 'pages/Layout/PageTitle';
import { providerService } from 'services/providers';

import { downloadcsv } from '../../../helpers/downloadcsv';

export const AgingWithPartsReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const now = new Date();

  const handleDownloadAgingWithPartsReport = async () => {
    setIsLoading(true);
    toast.info('Aguardando relatório');

    try {
      const { data } = await providerService.agingWithParts();
      console.log(data);
      await downloadcsv(`ingenico_aging_compecas`, data);
      console.log(data);
      toast.success('Relatório Gerado com sucesso');
    } catch (error) {
      console.error(error);
      toast.error('Falha ao gerar relatório');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <PageTitle>Aging Com Peças</PageTitle>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={3}>
          <Button fullWidth onClick={handleDownloadAgingWithPartsReport} loading={isLoading}>
            exportar relatório
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
